import logo from "../../../../public/projects/casagrand/images/logo/logo.png"



export const developersCasagrand = {
  name: `Casagrand Builder Properties in Bengaluru `,
  properties: [
    {
      image: "Casagrand - Elysium",
      price: "On Request",
      location: "Sector 31",
      bed: "2 - 3 BHK",
      state: "Bengaluru",
      developer: "Casagrand",
      size: "954 - 1149 sq.ft.",
      url: ``,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "Casagrand - Massimo",
      image: "",
      price: "On Request",
      location: "Bengaluru",
      projectlocation: "Wellesley Road",
      state: "Bengaluru",
      developer: "Casagrand",
      bed: "2-3-4 BR Apartments",
      size: "On Request",
      url: ``,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
        name: "Casagrand - Primrose",
        image: "",
        price: "On Request",
        location: "Bengaluru",
        projectlocation: "Wellesley Road",
        state: "Bengaluru",
        developer: "Casagrand",
        bed: "1 - 3 BR Apartments",
        size: "On Request",
        url: ``,
        form: {
          source_id: 11,
          api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
          api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
          sub_source_id: 130,
          builder_id: `103`,
          project_id: `477`,
          subject: "M3M Altitude", // Add or update the subject here
          to_email: "jatin.rohilla@propertystation.in",
        },
      },
      {
        name: "Casagrand - Aria",
        image: "",
        price: "On Request",
        location: "Bengaluru",
        projectlocation: "Wellesley Road",
        state: "Bengaluru",
        developer: "Casagrand",
        bed: "1 - 3 BR Apartments",
        size: "On Request",
        url: ``,
        form: {
          source_id: 11,
          api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
          api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
          sub_source_id: 130,
          builder_id: `103`,
          project_id: `477`,
          subject: "M3M Altitude", // Add or update the subject here
          to_email: "jatin.rohilla@propertystation.in",
        },
      },
      {
        name: "Casagrand - Madelyn",
        image: "",
        price: "On Request",
        location: "Bengaluru",
        projectlocation: "Wellesley Road",
        state: "Bengaluru",
        developer: "Casagrand",
        bed: "1 - 3 BR Apartments",
        size: "On Request",
        url: ``,
        form: {
          source_id: 11,
          api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
          api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
          sub_source_id: 130,
          builder_id: `103`,
          project_id: `477`,
          subject: "M3M Altitude", // Add or update the subject here
          to_email: "jatin.rohilla@propertystation.in",
        },
      },
  ],
};


export const Headers = {
  logo: logo,
  data: {
    experience: "1990",
  },
  about: `A real estate company dedicated to creating dreams and providing value is Casagrand Builder Private Limited. We have constructed more than 22 million square feet of premium residential real estate in Chennai, Bengaluru, and Coimbatore during the past 15 years.`,
};
